import React, { useState, useEffect } from "react";
import { Card, Descriptions, Button, Typography, Alert } from "antd";
import {
  ShopOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import { useAuth } from "../contexts/AuthContext";
import api from "../services/api";
import LoadingSpinner from "../components/UI/LoadingSpinner";

const { Title, Text } = Typography;

const formatPhone = (phone) => {
  if (!phone) return "-";
  const p = phone.replace(/\D/g, "");
  if (p.length === 10) return `${p.slice(0, 3)}-${p.slice(3, 6)}-${p.slice(6)}`;
  if (p.length === 9) return `${p.slice(0, 2)}-${p.slice(2, 5)}-${p.slice(5)}`;
  return phone;
};

const Company = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [company, setCompany] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (user?.current_company_id) {
      setError("");
      fetchCompany();
    }
  }, [user?.current_company_id]);

  const fetchCompany = async () => {
    try {
      setLoading(true);
      const response = await api.get("/companies");

      if (response.data.success && response.data.data) {
        setCompany(response.data.data);
      }
    } catch (error) {
      console.error("Fetch company error:", error);
      setError("ไม่สามารถโหลดข้อมูลบริษัทได้");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner tip="กำลังโหลดข้อมูลบริษัท..." />;
  }

  if (error) {
    return (
      <Alert
        message="ข้อผิดพลาด"
        description={error}
        type="error"
        showIcon
        action={<Button onClick={fetchCompany}>ลองใหม่</Button>}
      />
    );
  }

  return (
    <div style={{ maxWidth: 800, margin: "0 auto" }}>
      <Card>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <ShopOutlined
            style={{ fontSize: 48, color: "#1890ff", marginBottom: 16 }}
          />
          <Title level={2}>ข้อมูลบริษัท</Title>
          {user?.role === "multi_company_admin" &&
            user?.current_company_name && (
              <div style={{ marginBottom: 8 }}>
                <Text strong style={{ color: "#1890ff" }}>
                  กำลังจัดการ: {user.current_company_name}
                </Text>
              </div>
            )}
          <Text type="secondary">ข้อมูลโปรไฟล์บริษัท</Text>
        </div>

        <Descriptions
          bordered
          column={1}
          labelStyle={{ fontWeight: 600, width: 180, background: "#fafafa" }}
          contentStyle={{ background: "#fff" }}
        >
          <Descriptions.Item label="ชื่อบริษัท">
            {company?.name || "-"}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <span>
                <EnvironmentOutlined /> ที่อยู่
              </span>
            }
          >
            {company?.address || "-"}
          </Descriptions.Item>
          <Descriptions.Item
            label={
              <span>
                <PhoneOutlined /> เบอร์โทรศัพท์
              </span>
            }
          >
            {company?.phone ? (
              <span>
                <a
                  href={`tel:${company.phone}${company.phone_ext ? "," + company.phone_ext : ""}`}
                >
                  {formatPhone(company.phone)}
                </a>
                {company.phone_ext && (
                  <Text type="secondary"> ต่อ {company.phone_ext}</Text>
                )}
              </span>
            ) : (
              "-"
            )}
          </Descriptions.Item>
        </Descriptions>

        {company && (
          <div
            style={{
              marginTop: 24,
              padding: 12,
              background: "#f9f9f9",
              borderRadius: 8,
              textAlign: "center",
            }}
          >
            <Text type="secondary" style={{ fontSize: 12 }}>
              อัปเดตล่าสุด:{" "}
              {new Date(company.updated_at).toLocaleString("th-TH")}
            </Text>
          </div>
        )}
      </Card>
    </div>
  );
};

export default Company;
